import { render, staticRenderFns } from "./speakersEdition.vue?vue&type=template&id=1a85fc5b"
import script from "./speakersEdition.vue?vue&type=script&lang=js"
export * from "./speakersEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports